import React, { use, useEffect, useRef, useState } from "react";
import logo from "../Images/Logos/logo.png";
import ThirtyYearsImg from "../Images/Logos/30_Years_Poster_For_Janica.png";
import { Link, useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import Logo from "./Logo";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <section className="text-white mx-auto sm:h-28 h-36 bg-bgBlack">
      {/* <header className="text-white flex justify-between items-center p-2 z-10 w-full top-0 absolute"> */}

      <header className="border-b bg-bgBlack border-lightGray/10 fixed top-0 left-0 right-0 z-20">
        <div className="flex justify-between items-center p-1 sm:w-[90%] mx-auto">
          {/************************** Left - Logo **************************/}
          <div
            onClick={handleNavigation}
            className="flex xs:flex-row flex-col sm:gap-1 xs:items-center items-start  cursor-pointer"
          >
            <img src={logo} alt="Business Logo" className="sm:w-16 w-12" />
            <div className="uppercase">
              <h2 className="logo-font xs:text-xl text-base font-semibold tracking-wider">
                Janica
              </h2>
              <p className="logo-font1 sm:leading-none leading-4 xs:text-base text-sm">
                Electronics <br className="sm:hidden block" />{" "}
                <span className="text-xs">Pvt Ltd</span>
              </p>
            </div>
          </div>

          {/* ************************* Search Bar **************************/}

          <div className="flex bg-white text-black sm:p-2 p-1 items-center rounded sm:w-1/2">
            <input
              className="w-full outline-none rounded"
              placeholder="Search here"
            />
            <FaSearch className="text-mediumGray cursor-pointer" size={20} />
          </div>

          {/* ************************* Right - Anniversary Image **************************/}

          <div className="flex items-center">
            <img
              src={ThirtyYearsImg}
              alt="30 Years Celebration"
              className="sm:w-16 w-12"
            />
          </div>
        </div>
      </header>

      {/* ************************* Navigation Menu ************************* */}

      <div className="relative sm:text-base text-sm text-white sm:top-20 top-28">
        <ul className="flex flex-row sm:gap-5 gap-2 justify-around relative cursor-pointer items-center">
          <Link to={"/"}>
            <li className="hover:border-b-error hover:border-b-2">Home</li>
          </Link>
          <Link to="/products">
            {" "}
            <li className="hover:border-b-error hover:border-b-2">Products</li>
          </Link>
          {/* <Link to="/camera-solutions">
            <li className="hover:border-b-error hover:border-b-2">
              CCTV Solutions
            </li>
          </Link> */}
          {/* ************************* Shopping Tools Dropdown **************************/}

          {/* <li className="relative">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="cursor-pointer hover:border-b-error hover:border-b-2 "
            >
              Shopping Tools
            </button>
            {isOpen && (
              <div>
                <ul
                  ref={dropdownRef}
                  className=" text-black bg-white absolute mt-2 left-0 flex justify-center items-center flex-col shadow-md rounded-md p-3 w-52 z-10"
                >
                  <li className="p-1 hover:text-error">
                    <Link to="/solar-calculator"> Solar Saving Calculator</Link>
                  </li>
                  <li className="p-1 hover:text-error">Home Load Calculator</li>
                </ul>
              </div>
            )}
          </li> */}

          <li className="hover:border-b-error hover:border-b-2">
            <Link to="/solar-calculator"> Shopping tools</Link>
          </li>

          <li className="hover:border-b-error hover:border-b-2">
            <Link to="/contact-us">Contact us</Link>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Header;
